export const CyPushNeededInfo = {
  ButtonSyncNow: "ButtonSyncNow",
} as const;
